<template>
<div>
    <van-nav-bar
        title="我的证书"
        left-arrow
        @click-left="onClickLeft"
    />
    <div class="certificate-page" v-if="list.length">
        <div class="list"  v-for="item in list" :key="item.id">
            <div class="card" @click="showModel(item)">
                <div class="img-div">
                    <img src="../../../assets/images/account/zsbj.png" alt="" v-if="item.url==null || item.url==''" class="img">
                    <van-image :src="item.url" class="img" v-else>
                        <template v-slot:loading>
                            <van-loading type="spinner" size="20" />
                        </template>
                    </van-image>
                </div>
                <div class="right-info">
                    <p class="title">
                        {{item.businessName}}
                    </p>
                    <p class="from">
                        {{item.issuedBy}}
                    </p>
                    <p class="time">
                        {{item.certifiedTime.split(' ')[0]}}
                    </p>
                </div>
            </div>
        </div>
    </div>
    <div v-else>
        <img src="../../../assets/images/account/blank.png" class="blank-img"/>
        <p class="blank-txt">
            你还没证书哦，继续加油～
        </p>
    </div>

    <van-dialog class="tipDialog" v-model="showDialog" title="" :showConfirmButton="false">
        <img class="icon" src="../../../assets/images/account/tishi.png" alt="">
        <p class="title">提示</p>
        <p class="text">
            请先到个人资料页中完善信息
        </p>
        <div class="dialog-btn">
            <p class="button button1" @click="showDialog = false">
                取消
            </p>
            <p class="button button2" @click="handleConfirm">
                完善资料
            </p>
        </div>
    </van-dialog>

    <van-overlay :show="showOverlay" @click="showOverlay = false">
        <div class="wrapper" @click.stop>
            <div>
                <img :src="url" class="overlay-img" />
                <div class="img-close">
                    <van-icon name="clear" class="close" @click="showOverlay = false"/>
                </div>
            </div>
        </div>
    </van-overlay>
</div>
</template>
<script>
import { mapState } from 'vuex'
export default {
    name: 'certificate',
    data() {
        return {
            list: [],
            loading: false,
            finished: false,
            showOverlay: false,
            url:'',
            showDialog:false
        }
    },
    computed: {
		...mapState(['isNewSaas']),
	},
    mounted(){
        this.getData();
        if (window.history && window.history.pushState) {
            // 往历史记录里面添加一条新的当前页面的url
            history.pushState(null, null, document.URL);
            if(sessionStorage.getItem("certificateLocalUrl").indexOf('/saccount') != -1 || sessionStorage.getItem("certificateLocalUrl").indexOf('/personalCenter_new') != -1){
            // 给 popstate 绑定一个方法 监听页面刷新
                window.addEventListener('popstate', this.goPhone, false);
            }
       }
    },
    methods: {
        handleConfirm(){
            console.log('去完善资料')
            if(this.isNewSaas){
                this.$router.push('/myProfile_new')
            }else{
                this.$router.push('/myProfile')
            }
        },
        goPhone(){
            // var target = localStorage.getItem("certificateLocalUrl")
            // var targetPush=target.split('/')[1]
            if(this.isNewSaas){
                this.$router.push({
                    path: '/personalCenter_new'
                });
            }else{
                this.$router.push({
                    path: '/saccount'
                });
            }
        },
        onClickLeft() {
            // this.$router.go(-1);
            if(this.$route.query.backPath){
                this.$router.push({
                    path: this.$route.query.backPath
                });
            }else{
                if(this.isNewSaas){
                    this.$router.push({
                        path: '/personalCenter_new'
                    });
                }else{
                    this.$router.push({
                        path: '/saccount'
                    });
                }
            }
        },
        getData(){
            this.$api.certificate.getData({}).then(res => {
                if (res.data) {
                    this.list = res.data
                }
            })
        },
        // onLoad() {
        //     let timer = setTimeout(() => {	// 定时器仅针对本地数据渲染动画效果,项目中axios请求不需要定时器
        //         this.getData();					// 调用上面方法,请求数据
        //         this.page++;					// 分页数加一
        //         this.finished && clearTimeout(timer);//清除计时器
        //     }, 100);
        // },
        showModel(item) {
            this.$nextTick(() => {
                this.url = item.url;
            })
            this.$api.certificate.getCertificateWithCheck('id',item.id).then(res=>{
                if(res.data){
                    if(res.data.isAuthentication == 0 || (res.data.isAuthentication==1 && res.data.userAuthenStatus ==1)){ //不需要实名或者需要实名并且已实名
                        if(!this.url){
                            this.showDialog = true
                            return
                        }
                        this.showOverlay = true;
                    }else{
                        this.showOverlay = false;
                        // 进行实名认证
                        this.$router.push({
                            path: '/idcard'
                        })
                    }
                }else{
                     this.showOverlay = false;
                    // 进行实名认证
                    this.$router.push({
                        path: '/idcard'
                    })
                }
            })
        },
        downLoad() {
            let x=new XMLHttpRequest();
            x.open("GET", this.url, true);
            x.responseType = 'blob';
            x.onload=function(e){
                let url = window.URL.createObjectURL(x.response)
                let a = document.createElement('a');
                a.href = url
                a.download = ''
                a.click()
            }
            x.send();
        }
    },
    destroyed(){
        if(sessionStorage.getItem("certificateLocalUrl").indexOf('/saccount') != -1 || sessionStorage.getItem("certificateLocalUrl").indexOf('/personalCenter_new') != -1){
              window.removeEventListener('popstate', this.goPhone, false);
        }
  }
}
</script>
<style lang="stylus" scoped>
@import '../asset/css/certificate.styl'
.tipDialog {
    .dialog-btn{
        display: flex;
        margin:48px 0;
        .button{
            width: 236px;
            height: 80px;
            border-radius: 40px;
            border: 1PX solid #3860ff;
            text-align: center;
            line-height: 80px;
            color: #316FFF;
            &.button2{
                background: linear-gradient(136deg, #227FFF 0%, #316FFF 100%);
                border: none;
                margin-left: 22px;
                color: #fff;
            }
        }
    }
    .icon {
        display block
        width 228px
        height 164px
        margin 64px auto 0
    }
    .title {
        font-size: 40px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #202124;
        line-height: 40px;
        margin 16px 0 32px 0
    }
    .text {
        font-size: 32px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: #202124;
        line-height: 56px;
    }


}
</style>
